// Generated by CoffeeScript 2.4.1
(function() {
  var GET, POST, Weaver, WeaverObject, WeaverUser, cuid;

  cuid = require('cuid');

  Weaver = require('./Weaver');

  WeaverObject = require('./WeaverObject');

  GET = Weaver.GET;

  POST = Weaver.POST;

  WeaverUser = class WeaverUser extends WeaverObject {
    constructor(username, password1, email) {
      super(cuid(), username);
      this.password = password1;
      this.email = email;
      this.userId = this.id(); // needed server side
      this.username = this.name(); // needed server side
    }

    static get(authToken) {
      var user;
      user = new WeaverUser();
      user.authToken = authToken;
      return user;
    }

    static loadFromServerObject(user) {
      var u;
      u = new Weaver.User();
      u.populateFromServer(user);
      return u;
    }

    populateFromServer(serverUser) {
      this._id = serverUser.userId;
      this._name = serverUser.username;
      this.email = serverUser.email;
      this.firstname = serverUser.firstname;
      this.lastname = serverUser.lastname;
      this.active = serverUser.active;
      this.lastLogin = serverUser.lastLogin;
      this.lastPasswordChange = serverUser.lastPasswordChange;
      this.forcePasswordChange = serverUser.forcePasswordChange;
      this.userId = this.id(); // needed server side
      return this.username = this.name(); // needed server side
    }

    
    // Saves the user without signing up
    async create() {
      var key, ref, update, value;
      update = {};
      ref = this;
      for (key in ref) {
        value = ref[key];
        update[key] = value;
      }
      this.authToken = (await POST("user.signUp", update, "$SYSTEM"));
      delete this.password;
    }

    save() {
      var key, payload, ref, value;
      payload = {
        userId: this.id(),
        username: this.name()
      };
      ref = this;
      for (key in ref) {
        value = ref[key];
        if (key !== 'authToken') {
          payload[key] = value;
        }
      }
      return POST("user.update", {
        update: payload
      });
    }

    changePassword(password) {
      return POST("user.changePassword", {
        userId: this.id(),
        password
      });
    }

    // Saves the user and signs in as current user
    async signUp() {
      await this.create();
      return Weaver.getCoreManager().currentUser = this;
    }

    destroy() {
      return POST("user.delete", {
        id: this.id()
      }, "$SYSTEM");
    }

    async getRoles() {
      var i, len, r, results, roles;
      roles = (await POST("user.roles", {
        id: this.id()
      }));
      results = [];
      for (i = 0, len = roles.length; i < len; i++) {
        r = roles[i];
        results.push(Weaver.Role.loadFromServerObject(r));
      }
      return results;
    }

    async getProjects() {
      var i, len, list, p, results;
      list = (await POST("user.projects", {
        id: this.id()
      }));
      results = [];
      for (i = 0, len = list.length; i < len; i++) {
        p = list[i];
        results.push(Weaver.Project.loadFromServerObject(p));
      }
      return results;
    }

    static async list() {
      var i, len, results, u, users;
      users = (await GET("users"));
      results = [];
      for (i = 0, len = users.length; i < len; i++) {
        u = users[i];
        results.push(WeaverUser.loadFromServerObject(u));
      }
      return results;
    }

    static async listProjectUsers() {
      var i, len, project, results, u, users;
      project = Weaver.getCoreManager().currentProject;
      users = (await GET("projectUsers", {
        id: project.id
      }));
      results = [];
      for (i = 0, len = users.length; i < len; i++) {
        u = users[i];
        results.push(WeaverUser.loadFromServerObject(u));
      }
      return results;
    }

    async listDomains() {
      return (await GET('user.listDomains', {
        id: this.id()
      }));
    }

    static async load(userId) {
      var userObject;
      userObject = (await GET('user.get', {
        id: userId
      }));
      return WeaverUser.loadFromServerObject(userObject);
    }

  };

  // Export
  module.exports = WeaverUser;

}).call(this);
